if (screen.width < 980) {
  $(document).delegate(
    "#footer .footer_content_footer-menu .footer-menu-area1 .content-footer-menu .title-menu-footer",
    "click",
    function () {
      $(this).parent().toggleClass("active");
    }
  );
}

$(document).delegate(
  ".helper-float .btn-open-helper",
  "click",
  function () {
    $('.helper-float').toggleClass("active");
  }
);

$(document).delegate(
  ".helper-float .helper-content .btn-close-helper",
  "click",
  function () {
    $('.helper-float').toggleClass("active");
  }
);